import React, { Component, useState, useEffect } from "react";
import {
  Statistic,
  Card,
  Row,
  Col,
  Divider,
  Progress,
  InputNumber,
  Checkbox,
  Button,
  Tooltip,
  Icon,
} from "antd";
import {
  CaretUpOutlined,
  CaretDownOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import Currency from "react-currency-formatter";
// import DashboardApi from '../../../tools/Api/dashboard.api';
import { ScreenSize } from "utils/constants";
import moment from "moment";
import TweenOne from "rc-tween-one";
import Children from "rc-tween-one/lib/plugin/ChildrenPlugin";
import PropTypes from "prop-types";
import Locale from "react-intl-universal";

TweenOne.plugins.push(Children);

class Demo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      animation: null,
      formatMoney: false,
    };
  }

  componentWillReceiveProps(props) {
    // console.log("qwe", props);
    if (props.data) {
      this.setState({
        animation: {
          Children: {
            value: props.data,
            floatLength: 0,
            formatMoney: false,
          },
          duration: 1000,
        },
      });
    }
  }

  // componentWillReceiveProps(props) {
  //   if (props.data) {
  //     this.setState({
  //       animation: {
  //         Children: {
  //           value: props.data,
  //           floatLength: 2,
  //           formatMoney: false
  //         },
  //         duration: 1000
  //       }
  //     });
  //   }
  // }

  onChangeMoney = (e) => {
    this.setState({
      formatMoney: e.target.checked,
    });
  };

  onClick = () => {
    const { value, formatMoney } = this.state;
    this.setState({
      animation: {
        Children: {
          value: typeof value === "number" ? value : 10000,
          floatLength: 0,
          formatMoney,
        },
        duration: 1000,
      },
    });
  };

  onChange = (value) => {
    console.log(value);
    this.setState({
      value,
    });
  };

  render() {
    return (
      <div
      // style={{
      //   display: 'flex',
      //   height: '100%',
      //   minHeight: '220px',
      //   alignItems: 'center',
      //   textAlign: 'center'
      // }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <TweenOne
            animation={this.state.animation}
            style={{ fontSize: 64, fontWeight: "bold", color: "black" }}
          >
            0
          </TweenOne>
          {/* <InputNumber
            defaultValue={this.state.value}
            onChange={this.onChange}
          />
          <Checkbox style={{ margin: '0 16px' }} onChange={this.onChangeMoney}>
            {' '}
            to money
          </Checkbox>
          <Button
            type="primary"
            style={{ marginBottom: 32 }}
            onClick={this.onClick}>
            Start
          </Button> */}
        </div>
      </div>
    );
  }
}
Demo.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  paused: PropTypes.bool,
};

const Statistics = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [dateRange, setDateRange] = useState([
    // moment()
    //   .subtract(7, "day")
    //   .startOf("day")
    moment().subtract(3, "month"),
    moment().endOf("day"),
  ]);

  useEffect(() => {
    // GetSales();

    if (props.data) {
      setData(props.data);
      console.log("props", props);
    }
  }, [props]);

  // const GetSales = async () => {
  //   // message.loading("Loading data...");
  //   setLoading(true);
  //   const res = await DashboardApi.getSales(
  //     dateRange[0].unix(),
  //     dateRange[1].unix()
  //   );
  //   console.log('sale', res);

  //   if (res.status === 200) {
  //     setLoading(false);
  //     setData(res.data);
  //   } else {
  //     setLoading(false);

  //     ResponseError(res);
  //   }
  // };

  const StatisticsLabel = (title, number) => {
    return (
      <div
        style={{
          backgroundColor: "rgba(0,0,0,0.1)",
          padding: 16,
          borderRadius: 10,
          height: "100%",
          border: "1px solid rgba(0,0,0,0.15)",
          // boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.15)'
        }}
      >
        <Row justify="center">
          <Col>
            <Demo data={number} />

            {/* <Row
              justify="center"
              style={{
                fontSize: 64,
                fontWeight: 'bold',
                color: 'black'
              }}>
              {number}
            </Row> */}
            <Row justify="center" align="middle" gutter={16}>
              <Col style={{ fontSize: 24, fontWeight: 500, color: "black" }}>
                {title}

                {title !== "Total New Advisee" && (
                  <Tooltip
                    title={Locale.get("Dashboard.dashboardStats.toolTipTitle")}
                  >
                    <QuestionCircleOutlined
                      style={{
                        color: "rgba(0,0,0,0.65)",
                        fontSize: 14,
                        transform: "translate(12px, -2px)",
                      }}
                    />
                  </Tooltip>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div>
      <Row gutter={16}>
        <Col
          xs={24}
          md={12}
          xl={6}
          style={{
            marginBottom: window.innerWidth < ScreenSize.md ? 16 : 16,
          }}
        >
          {StatisticsLabel(
            Locale.get("Dashboard.dashboardStats.statsLabel_1"),
            data.totalNewAdvisee
          )}
        </Col>
        <Col
          xs={24}
          md={12}
          xl={6}
          style={{
            marginBottom: window.innerWidth < ScreenSize.md ? 16 : 16,
          }}
        >
          {StatisticsLabel(
            Locale.get("Dashboard.dashboardStats.statsLabel_2"),
            data.totalAdvisee
          )}
        </Col>
        <Col
          xs={24}
          md={12}
          xl={6}
          style={{
            marginBottom: window.innerWidth < ScreenSize.md ? 16 : 16,
          }}
        >
          {StatisticsLabel(
            Locale.get("Dashboard.dashboardStats.statsLabel_3"),
            data.totalDeal
          )}
        </Col>
        <Col
          xs={24}
          md={12}
          xl={6}
          style={{
            marginBottom: window.innerWidth < ScreenSize.md ? 16 : 16,
          }}
        >
          {StatisticsLabel(
            Locale.get("Dashboard.dashboardStats.statsLabel_4"),
            data.totalClient
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Statistics;
